import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllHolidays = async (uid, SchoolID) => {
  if (uid && SchoolID) {
    try {
      const HolidaysCollection = collection(db, "Holidays");

      const q = query(
        HolidaysCollection,
        where("uid", "==", uid),
        where("SchoolID", "==", SchoolID),
        where("IsDeleted", "==", false)
      );
      const HolidaysSnapshot = await getDocs(q);

      let HolidaysData = [];

      HolidaysSnapshot.forEach((doc) => {
        HolidaysData.push({ ...doc.data(), id: doc.id });
      });
      return HolidaysData;
    } catch (error) {
      console.log(error);
    }
  }
};

export default GetAllHolidays;
